export default "__VITE_ASSET__9waK1U2H__"